import { useQuery } from "@tanstack/react-query";
import { featuresApi } from "../api/features";

export default function Features() {
  const bd = useQuery({ queryKey: ["feat-breakdown"], queryFn: () => featuresApi.breakdown(7) });
  const errs = useQuery({ queryKey: ["feat-errors"], queryFn: () => featuresApi.errors(7) });

  return (
    <div className="space-y-6">
      <h2 className="text-lg font-semibold text-slate-900">Features</h2>

      <section>
        <h3 className="mb-2 text-sm font-medium text-slate-700">Tool usage (last 7 days)</h3>
        <div className="overflow-hidden rounded-lg border border-slate-200 bg-white">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-left text-xs uppercase text-slate-500">
              <tr>
                <th className="px-4 py-2">Source</th>
                <th className="px-4 py-2">Tool</th>
                <th className="px-4 py-2 text-right">Count</th>
                <th className="px-4 py-2 text-right">Failures</th>
                <th className="px-4 py-2 text-right">Failure rate</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {bd.data?.map((r, i) => (
                <tr key={i}>
                  <td className="px-4 py-2">{r.source}</td>
                  <td className="px-4 py-2 font-mono text-xs">{r.tool_name ?? "—"}</td>
                  <td className="px-4 py-2 text-right">{r.count}</td>
                  <td className="px-4 py-2 text-right">{r.failures}</td>
                  <td className="px-4 py-2 text-right">{(r.failure_rate * 100).toFixed(1)}%</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      <section>
        <h3 className="mb-2 text-sm font-medium text-slate-700">API errors by model (last 7 days)</h3>
        <div className="overflow-hidden rounded-lg border border-slate-200 bg-white">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-left text-xs uppercase text-slate-500">
              <tr>
                <th className="px-4 py-2">Model</th>
                <th className="px-4 py-2">Status code</th>
                <th className="px-4 py-2 text-right">Count</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {errs.data?.map((r, i) => (
                <tr key={i}>
                  <td className="px-4 py-2 font-mono text-xs">{r.model ?? "—"}</td>
                  <td className="px-4 py-2">{r.status_code ?? "—"}</td>
                  <td className="px-4 py-2 text-right">{r.count}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}
